import { MIS_ACTION, STATUS } from "../constant";

const initState = {
  data: [],
  projectDetailData: null,
  activeReport: "FLAT_FILE",
  schemesList: [],
  projectStatusList: [],
  implementationModesList: [],
  flatFileReport: [],
  issueCategories: [],
  sectorsList: [],
  issueSubCategoriesList: [],
  downloadSponoringMinistry: [],
  downloadReport: "",
  downloadInProgress: false,
  misFlatFileStatus: null,
  issueSubCategoriesListStatus: "",
  downloadIssueUrlDTO: null,
  misListData: null,
  misReportList: [],
  misList: [],
  stateProjectsList: [],
  selectedState: "",
  selectedMonitoring: "",
  selectMeetingType: {
    label: "Cabinet Secretariat",
    name: "Cabinet Secretariat",
    optionName: "Cabinet Secretariat",
    value: "Cabinet Secretariat"
  },
  misIssueList: [],
  agendaList: [],
  issueList: [],
  timeLasped: {},
  issuesPending: {},
  issuesResolved: {},
  issuesReviewed: {},
  issuesPending: {},
  meetingsCount: {},
  meetingsDate: {},
  meetingAppendDates: [],
  togglestateMonitoring: false,
  issueUrl: "",
  isLoading: false
};

export default function mis(state = initState, action) {
  switch (action.type) {
    case MIS_ACTION.MIS_FILTER_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.MIS_FILTER_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.MIS_FILTER_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.PROJECT_MINISTRY_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.PROJECT_MINISTRY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.PROJECT_MINISTRY_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.PROJECT_SCHEME_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.PROJECT_SCHEME_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.PROJECT_SCHEME_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.PROJECT_MULTI_LOCATION_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.PROJECT_MULTI_LOCATION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.PROJECT_MULTI_LOCATION_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.PROJECT_SINGLE_LOCATION_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.PROJECT_SINGLE_LOCATION_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.PROJECT_SINGLE_LOCATION_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.ISSUE_STATE_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.ISSUE_STATE_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.ISSUE_STATE_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.ISSUE_STATUS_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.ISSUE_STATUS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.ISSUE_STATUS_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.PROJECT_STATUS_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.ETCH_STATE_PROJECT_REPORT_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.PROJECT_STATUS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.FETCH_STATE_PROJECT_REPORT_SUCCESS: {
      return {
        ...state,
        stateProjectsList: action.payload,

        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.PROJECT_STATUS_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };
    case MIS_ACTION.FETCH_STATE_PROJECT_REPORT_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_ISSUE_LIST_DATA_START: {
      return {
        ...state,
        misFlatFileStatus: STATUS.LOADING,
        agendaList: []
      };
    }
    case MIS_ACTION.STATES_ISSUE_LIST_DATA_SUCCESS: {
      return {
        ...state,

        agendaList: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.SCHEME_PROJECT_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.SCHEME_PROJECT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.SCHEME_PROJECT_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };

    case MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_SUCCESS: {
      return {
        ...state,
        issuesReviewed: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_MIS_ISSUES_RESOLVED_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };

    case MIS_ACTION.STATES_MIS_ISSUES_RESOLVED_SUCCESS: {
      return {
        ...state,
        issuesResolved: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.STATES_MIS_ISSUES_RESOLVED_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_MIS_ISSUES_PENDING_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };

    case MIS_ACTION.STATES_MIS_ISSUES_PENDING_SUCCESS: {
      return {
        ...state,
        issuesPending: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.STATES_MIS_ISSUES_PENDING_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_MIS_TIMELINE_LASPSED_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };

    case MIS_ACTION.STATES_MIS_TIMELINE_LASPSED_SUCCESS: {
      return {
        ...state,
        timeLasped: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.STATES_MIS_TIMELINE_LASPSED_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_MIS_MEETING_COUNT_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };

    case MIS_ACTION.STATES__MIS_MEETING_COUNT_SUCCESS: {
      return {
        ...state,
        meetingsCount: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.STATES__MIS_MEETING_COUNT_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.STATES_MIS_MEETING_DATE_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };

    case MIS_ACTION.STATES__MIS_MEETING_DATE_SUCCESS: {
      // console.log("reducer reducer reducer  ", action.payload)
      return {
        ...state,
        meetingsDate: action.payload,
        meetingAppendDates: { ...action.payload },
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.STATES__MIS_MEETING_DATE_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };
    case MIS_ACTION.TOGGLE_STATE_MONITORING: {
      //console.log("reducer reducer reducer  ", action.payload)
      return {
        togglestateMonitoring: action.payload
      };
    }

    case MIS_ACTION.ISSUE_SUMMARY_URL_START:
      return { ...state, isLoading: true, data: [] };

    case MIS_ACTION.ISSUE_SUMMARY_URL_SUCCESS: {
      //console.log("reducer url", action.payload.status);
      return {
        ...state,
        issueUrl: action.payload ? action.payload.data.url : null,
        //isLoading: action.payload ?(!action.payload.status ? true : false) : false
        //isLoading: action.payload ? false : true
        isLoading: false
      };
    }
    case MIS_ACTION.ISSUE_SUMMARY_URL_FAILURE:
      return { ...state, isLoading: false };

    case MIS_ACTION.ISSUE_SUMMARY_CREATE_FILE_START:
      return { ...state, isLoading: true, data: [] };

    case MIS_ACTION.ISSUE_SUMMARY_CREATE_FILE_SUCCESS: {
      console.log("reducer url", action.payload);
      return {
        ...state,
        issueUrl: action.payload,
        isLoading: true
      };
    }
    case MIS_ACTION.ISSUE_SUMMARY_CREATE_FILE_FAILURE:
      return { ...state, isLoading: false };

    case MIS_ACTION.FETCH_PROJECT_REPORT_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.FETCH_PROJECT_REPORT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_PROJECT_REPORT_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.FETCH_PROJECT_DETAIL_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.FETCH_PROJECT_DETAIL_SUCCESS: {
      return {
        ...state,
        projectDetailData: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_PROJECT_DETAIL_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.ACTIVE_REPORT:
      return { ...state, activeReport: action.params };

    case MIS_ACTION.FETCH_ALL_SCHEMES_START:
      return { ...state, misStatus: STATUS.LOADING };
    case MIS_ACTION.FETCH_ALL_SCHEMES_SUCCESS: {
      return {
        ...state,
        schemesList: action.payload,
        misStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.SELECTED_MONITORING_VALUE: {
      return {
        ...state,
        selectedMonitoring: action.payload
        //misStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.SELECTED_MEETING_VALUE: {
      //console.log("???????????????????", action.payload)
      return {
        ...state,
        selectMeetingType: action.payload
        //misStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.CLEAR_MONITORING_VALUE: {
      return {
        ...state,
        selectedMonitoring: {}
        //misStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.SELECTED_STATE_VALUE: {
      return {
        ...state,
        selectedState: action.payload
        //misStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.CLEAR_STATE_VALUE: {
      return {
        ...state,
        selectedState: {}
        //misStatus: STATUS.SUCCESS
      };
    }

    //      GET_MOMS_START:"GET_MOMS_START",
    // GET_MOMS_SUCCESS: "GET_MOMS_SUCCESS",
    // GET_MOMS_FAILURE:"GET_MOMS_FAILURE",

    case MIS_ACTION.GET_MOMS_SUCCESS: {
      return {
        ...state,
        issueList: action.payload
        //misStatus: STATUS.SUCCESS
      };
    }

    case MIS_ACTION.FETCH_ALL_PROJECT_STATUS_START:
      return { ...state, misStatus: STATUS.LOADING };
    case MIS_ACTION.FETCH_ALL_PROJECT_STATUS_SUCCESS: {
      return {
        ...state,
        projectStatusList: action.payload,
        misStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_ALL_PROJECT_STATUS_FAILURE:
      return { ...state, misStatus: STATUS.ERROR };

    case MIS_ACTION.FETCH_IMPLEMENTATION_MODES_START:
      return { ...state, misStatus: STATUS.LOADING };
    case MIS_ACTION.FETCH_IMPLEMENTATION_MODES_SUCCESS: {
      return {
        ...state,
        implementationModesList: action.payload,
        misStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_IMPLEMENTATION_MODES_FAILURE:
      return { ...state, misStatus: STATUS.ERROR };

    case MIS_ACTION.FETCH_FLAT_FILE_REPORT_START:
      return { ...state, misFlatFileStatus: STATUS.LOADING, data: [] };
    case MIS_ACTION.FETCH_FLAT_FILE_REPORT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        misFlatFileStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_FLAT_FILE_REPORT_FAILURE:
      return { ...state, misFlatFileStatus: STATUS.ERROR };

    case MIS_ACTION.FETCH_ALL_ISSUE_CATEGORY_START:
      return { ...state, misStatus: STATUS.LOADING };
    case MIS_ACTION.FETCH_ALL_ISSUE_CATEGORY_SUCCESS: {
      return {
        ...state,
        issueCategories: action.payload,
        misStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_ALL_ISSUE_CATEGORY_FAILURE:
      return { ...state, misStatus: STATUS.ERROR };

    case MIS_ACTION.FETCH_ALL_SECTORS_START:
      return { ...state, misStatus: STATUS.LOADING };
    case MIS_ACTION.FETCH_ALL_SECTORS_SUCCESS: {
      return {
        ...state,
        sectorsList: action.payload,
        misStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_ALL_SECTORS_FAILURE:
      return { ...state, misStatus: STATUS.ERROR };

    case MIS_ACTION.FETCH_ISSUE_SUB_CATEGORIES_START:
      return { ...state, issueSubCategoriesListStatus: STATUS.LOADING };
    case MIS_ACTION.FETCH_ISSUE_SUB_CATEGORIES_SUCCESS: {
      return {
        ...state,
        issueSubCategoriesList: action.payload,
        issueSubCategoriesListStatus: STATUS.SUCCESS
      };
    }
    case MIS_ACTION.FETCH_ISSUE_SUB_CATEGORIES_FAILURE:
      return { ...state, issueSubCategoriesListStatus: STATUS.ERROR };

    case MIS_ACTION.DOWNLOAD_PROJECT_SUMMARY_START:
      return { ...state, misStatus: STATUS.LOADING };
    case MIS_ACTION.DOWNLOAD_PROJECT_SUMMARY_SUCCESS: {
      return {
        ...state,
        downloadReport: action.payload,
        misStatus: STATUS.SUCCESS,
        downloadInProgress: true
      };
    }
    case MIS_ACTION.DOWNLOAD_PROJECT_SUMMARY_FAILURE:
      return { ...state, misStatus: STATUS.ERROR, downloadInProgress: false };
    case MIS_ACTION.DOWNLOAD_MIS_SUMMARY_STATUS:
      return { ...state, downloadInProgress: false };

    case MIS_ACTION.STATES_DATA_START:
      return { ...state, statesStatus: STATUS.LOADING };

    case MIS_ACTION.STATES_DATA_SUCCESS:
      return {
        ...state,
        statesStatus: STATUS.SUCCESS,
        statesList: action.payload
      };

    case MIS_ACTION.STATES_DATA_FAILURE:
      return { ...state, statesStatus: STATUS.ERROR };

    // case MIS_ACTION.STATES_MIS_LIST_DATA_START: {
    //   return { ...state, misStatus: STATUS.LOADING,  misFlatFileStatus: STATUS.LOADING,
    //     misIssueList: []}
    // }
    case MIS_ACTION.STATES_MIS_LIST_DATA_SUCCESS: {
      return {
        ...state,
        //misFlatFileStatus: STATUS.SUCCESS,
        misIssueList: action.payload
      };
    }
    case MIS_ACTION.STATES_MIS_LIST_DATA_FAILURE: {
      return { ...state, misStatus: STATUS.ERROR };
    }
    case MIS_ACTION.STATES_MIS_REPORT_LIST_DATA_START: {
      return { ...state, misFlatFileStatus: STATUS.LOADING, misReportList: [] };
    }
    case MIS_ACTION.STATES_MIS_REPORT_LIST_DATA_SUCCESS: {
      return {
        ...state,
        misFlatFileStatus: STATUS.SUCCESS,
        //misReportStatus: STATUS.SUCCESS,
        misReportList: action.payload
      };
    }
    case MIS_ACTION.STATES_MIS_REPORT_LIST_DATA_FAILURE: {
      return { ...state, misFlatFileStatus: STATUS.ERROR };
    }
    case MIS_ACTION.DOWNLOAD_ISSUE_COMMENT_START:
      return {
        ...state,
        downloadInProgress: true,
        downloadIssueUrlDTO: null,
        downloadUserDetailsDTO: null
      };

    case MIS_ACTION.DOWNLOAD_ISSUE_COMMENT_SUCCESS:
      return { ...state, downloadIssueUrlDTO: action.data };

    case MIS_ACTION.DOWNLOAD_ISSUE_COMMENT_URL_SUCCESS:
      return {
        ...state,
        downloadInProgress: false,
        downloadIssueUrlDTO: action.data
      };

    case MIS_ACTION.DOWNLOAD_ISSUE_COMMENT_FAILURE:
      return { ...state, downloadInProgress: false, downloadIssueUrlDTO: null };

    case MIS_ACTION.DOWNLOAD_USER_DETAILS_START:
      return {
        ...state,
        downloadInProgress: true,
        downloadUserDetailsDTO: null
      };

    case MIS_ACTION.DOWNLOAD_USER_DETAILS_SUCCESS:
      return { ...state, downloadUserDetailsDTO: action.payload };

    case MIS_ACTION.DOWNLOAD_USER_DETAILS_FAILURE:
      return {
        ...state,
        downloadInProgress: false,
        downloadUserDetailsDTO: null
      };

    case MIS_ACTION.DOWNLOAD_SPONORING_MINISTRY_START:
      return {
        ...state,
        downloadInProgress: true,
        downloadSponoringMinistry: null
      };

    case MIS_ACTION.DOWNLOAD_SPONORING_MINISTRY_SUCCESS:
      return { ...state, downloadSponoringMinistry: action.payload };

    case MIS_ACTION.DOWNLOAD_SPONORING_MINISTRY_FAILURE:
      return {
        ...state,
        downloadInProgress: false,
        downloadSponoringMinistry: null
      };

    case MIS_ACTION.DOCUMENTS_DATA_START:
      return { ...state, documentsStatusLoader: true };

    case MIS_ACTION.DOCUMENTS_DATA_SUCCESS:
      return {
        ...state,
        documentsStatusLoader: false,
        documentsList: action.payload
      };

    case MIS_ACTION.DOCUMENTS_DATA_FAILURE:
      return { ...state, documentsStatusLoader: false };

    case MIS_ACTION.GET_DD_BY_PARENTID_START:
      return { ...state, getDdByParentIdsLoader: true };

    case MIS_ACTION.GET_DD_BY_PARENTID_SUCCESS:
      return {
        ...state,
        getDdByParentIdsLoader: false,
        ddByParentIdsList: action.payload && action.payload.data
      };

    case MIS_ACTION.GET_DD_BY_PARENTID_FAILURE:
      return { ...state, getDdByParentIdsLoader: false };

    default:
      return state;
  }
}
